import {Action} from 'redux'
import {REHYDRATE} from 'redux-persist/constants'
import {IState} from './model'

const initialState: IState = {
  isHydrated: false,
}

const reducer = (state: IState = initialState, action: Action): IState => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...state,
        isHydrated: true,
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/persist/reducer.ts